var map = {
	"./SIH.png": 357,
	"./aavhan.png": 358,
	"./billingFastLogo.png": 359,
	"./cerebraniumLogo.png": 360,
	"./error404.gif": 361,
	"./finra.png": 362,
	"./godrejInfoTechLogo.svg": 363,
	"./kiranafast.png": 364,
	"./myracleLogo.webp": 365
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 356;